import {mapPost, fetchWordPressEdition} from "../lib/wordpress";
export let STORIES = [];
export let TICKER = [];
export let SECONDARY = [];
export let NEWSROOM_MORE = [];
export let MOST_READ = [];
export let EDITORS_PICKS = [];
export let SPONSORED = [];
let authors = new Map();
let loading;
export let bootDate = null;
export function isEditionFresh(now = Date.now()) {
 const at = Date.parse(bootDate || '');
 return Number.isFinite(at) && now >= at && now - at < 60000;
}
export function seedEdition(data) { STORIES = []; bootDate = data.renderedAt || null; applyEdition(data); }
function applyEdition(data) {
 const posts = (data.stories || data.posts.map(mapPost)).sort((a,b)=>b.timestamp-a.timestamp);
 const merged = new Map(STORIES.map(p=>[p.id,p]));
 posts.forEach(p=>merged.set(p.id,p));
 STORIES = [...merged.values()].sort((a,b)=>b.timestamp-a.timestamp);
 const latest = STORIES.slice(0,60);
 TICKER = latest.slice(0,6).map(s=>({id:s.id,text:s.title}));
 NEWSROOM_MORE = latest.slice(2,5); SECONDARY = latest.slice(5,11);
 MOST_READ = latest.slice(0,6);
 EDITORS_PICKS = ['sports','opinions','bantaba'].map(cat=>getCategoryStories(cat)[0]).filter(Boolean).map(s=>({id:s.id,note:s.excerpt}));
 SPONSORED = getCategoryStories('advertisement').slice(0,3).map(s=>({...s,url:'/story/'+s.id,brand:'The Standard',note:s.excerpt}));
 authors = new Map();
 for (const story of STORIES) for (const author of story.authors?.length ? story.authors : [story.authorRecord].filter(Boolean)) {
   const key=authorSlug(author.name); if(!authors.has(key)) authors.set(key,author);
 }
}
export const hydrateStories = async () => {
 if (loading) return loading;
 loading=(async()=>{
  if (!STORIES.length) {
   const response=await fetch('/wordpress-snapshot.json');
   if(!response.ok) throw new Error('Unable to load WordPress stories');
   applyEdition(await response.json());
  }
  return true;
 })().finally(()=>{loading=null});
 return loading;
};
export const refreshWordPress = async () => {
 try {applyEdition(await fetchWordPressEdition());bootDate=new Date().toISOString();return true;}catch{return false;}
};
export const hydrateFrontpage = async () => false;
export const getFrontpageSlots = () => ({});
export const allStories = () => STORIES;
export const searchIndex = () => STORIES;
export const getHeroLead = () => STORIES[0];
export const getPrevLead = () => STORIES[1] || STORIES[0];
export const getStoryById = id => STORIES.find(s=>s.id===id || String(s.wpId)===id) || null;
export const getCategoryStories = id => id==='all-news' ? STORIES : STORIES.filter(s=>s.categorySlugs.includes(id));
export const getStoryCategory = id => getStoryById(id)?.category || null;
export const getGambiaNewsList = () => getCategoryStories('gambia-news');
export const getEffectiveSections = () => ['sports','opinions','bantaba','politics'].map(id=>{
 const stories=getCategoryStories(id);return stories.length ? {id,kicker:CATEGORY_LABELS[id],lead:stories[0],stack:stories.slice(1,6),links:stories.slice(6,11)} : null;
}).filter(Boolean);
export const authorSlug = name => (name||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
const storyCredits=s=>s.authors?.length?s.authors:[s.authorRecord].filter(Boolean);
const matchingAuthor=(s,slug)=>storyCredits(s).find(a=>authorSlug(a.name)===slug||String(a.id)===slug);
export const getAuthorName = slug => STORIES.map(s=>matchingAuthor(s,slug)).find(Boolean)?.name || null;
export const getStoriesByAuthor = slug => STORIES.filter(s=>matchingAuthor(s,slug));
export const getAuthorRecord = slug => authors.get(slug) || STORIES.map(s=>matchingAuthor(s,slug)).find(Boolean) || null;
export const SITE = {
  name: "The Standard",
  strapline: "Latest Gambia News, Breaking News Gambia",
  date: "Friday, October 9, 2026",
  weather: "29.2°C",
  city: "City of Banjul",
  about:
    "The Standard Newspaper brings the Latest News from the Gambia, Africa and the World. Get live news and latest stories from Politics, Business, Technology, Sports and more. The newspaper is published and printed by XL Standard Co. Ltd. located at Kairaba Avenue, Fajara. Opposite The Butchers Shop Restaurant.",
  telephone: "+220 87 745 2126 / +220 87 708 1234",
  email: "ads@standard.gm",
  copyright: "© 2026 The Standard Newspaper (The Gambia)",
  siteCredit: "Site by DigiTech Solutions",
  socials: {
    facebook: "https://www.facebook.com/standardgambia",
    x: "https://x.com/standardgambia",
    youtube: "https://www.youtube.com/channel/UCk6BJGqGXwzA25m49WvqADg",
  },
};

export const NAV = [
  { label: "All News", href: "/news" },
  { label: "Sponsored", href: "/category/advertisement" },
  { label: "Bantaba", href: "/category/bantaba" },
  { label: "Sports", href: "/category/sports" },
  { label: "Politics", href: "/category/politics" },
  { label: "Opinions", href: "/category/opinions" },
];

export const NAV_MORE = [
  "Biography",
  "Daily Poem",
  "Gossip",
  "History",
  "Short Story",
  "Sister Speaks",
  "Society",
  "The Hub",
];

export const VIDEOS = [
  {
    id: "laSPhITC-eA",
    title: "Special Interview with Omar Bah, Yankuba Darboe, Commissioner General, Gambia Revenue Authority",
    kicker: "Special Interview",
    img: "https://i.ytimg.com/vi/laSPhITC-eA/mqdefault.jpg",
    imgAlt: "Gambia Revenue Authority officials seated for a studio interview",
  },
  {
    id: "ShDTlwrq_FM",
    title: "Election series: Mayor Talib Ahmad Bensouda",
    kicker: "Election Series",
    img: "https://i.ytimg.com/vi/ShDTlwrq_FM/mqdefault.jpg",
    imgAlt: "Mayor Talib Ahmad Bensouda interviewed in The Standard's election series",
  },
  {
    id: "TFvFaG0eAgA",
    title: "Bantaba with Alagie Manneh - Lamin Manneh, Disability Advocate, Executive Director of NODD",
    kicker: "Bantaba",
    img: "https://i.ytimg.com/vi/TFvFaG0eAgA/mqdefault.jpg",
    imgAlt: "Bantaba studio conversation with disability advocate Lamin Manneh",
  },
];

export const CATEGORY_LABELS = {
  "all-news": "All News",
  sports: "Sports",
  politics: "Politics",
  opinions: "Opinions",
  bantaba: "Bantaba",
  "gambia-news": "Gambia News",
  advertisement: "Sponsored Content",
  biography: "Biography",
  "daily-poem": "Daily Poem",
  gossip: "Gossip",
  history: "History",
  "short-story": "Short Story",
  "sister-speaks": "Sister Speaks",
  society: "Society",
  "the-hub": "The Hub",
};


export const mergeAuthorPosts = posts => applyEdition({posts});
